<template>
    <!--答题页面-->
    <div class="container-head-top padding-top"  v-loading="loading">
        <!--人格测试end-->
        <div  class="personality"  v-show="!loading">
            <div class="backmenu"><a href="javascript:;">首页</a> &gt; <a href="javascript:;">生涯规划</a> &gt; <a href="javascript:;" @click="$router.push('/teacherCenterDashboard/careerplanningDashboard/careerassessment')"> 生涯测评</a> &gt; <span href="javascript:;">{{$route.query.titleName}}</span></div>
            <!--兴趣测试start-->
            <div  class="topic">
                <div class="topicTitle">
                    <div>{{$route.query.titleName}}</div>
                </div>
                <div class="progress_bar">
                    <div style="text-align: right;font-size: 15px;" >
                        {{currentPage+1}}/{{this.tilist.length}}
                    </div>

                    <span style="width:89%;">
                        <el-progress :percentage="percentage" :format="format" :show-text="false"></el-progress>
                    </span>

                </div>
                <div >
                    <el-collapse-transition>
                        <div v-show="controllerTopicShow" class="ticontent" v-for="(valueCD,indexct) in dataShow" :key="indexct">
                            <div>
                                {{currentPage+1}},{{valueCD.content}}
                            </div>
                            <div v-for="(danxuan,indexOne) in valueCD.options" :key="indexOne" class="ticontent-input">
                                <label class="settingBtnStyle" :for="currentPage+danxuan.value" @click.prevent="increase();otherincrease();nextPage(String(valueCD.no),Number(danxuan.value))">
                                    <input type="radio"  :name="currentPage+danxuan.value" :checked="danxuan.value===zhiRadio">
                                    {{danxuan.content}}
                                </label>
                                <!--                                <el-radio v-model="itemSon.value" @change="nextPage(String(valueCD.no), dataShow)" :label="itemSon.content"> </el-radio>-->
                            </div>
                        </div>

                    </el-collapse-transition>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
    import Vue from 'vue'
    Vue.component(CollapseTransition.name, CollapseTransition);
    import {commitAllTopic, startceping} from "../../../config";
    import {decrypt, getStore} from "../../../assets/static/global/global";
    export default {
        name: "Personality_type_test",
        data(){
            return{
                //控制当前页面是否在生成报告中
                loading:false,
                //监听内容每做完一题加一
                listenTopic:0,
                zhiRadio:null,
                //控制题目显示，消失
                controllerTopicShow:true,
                show:false,
                //当前进入副页后当前所显示的内容
                intoDQContent:[],
                //单选选中
                radiocheck:'',
                //题目类型编号
                record_id:'',
                //页面容量
                pageSize:1,
                //当前页
                currentPage:0,
                daohangname:'',
                customColor: '#409eff',
                percentage:1,
                colors:[
                    {color: '#f56c6c', percentage: 20},
                    {color: '#e6a23c', percentage: 40},
                    {color: '#5cb87a', percentage: 60},
                    {color: '#1989fa', percentage: 80},
                    {color: '#6f7ad3', percentage: 100}
                ],
                tilist:[],
                //放置题目的选项内容
                allTopicOptions:new Map()
            }
        },
        computed:{
            dataShow(){
                let start = this.currentPage*this.pageSize;
                let end = Math.min((this.currentPage+1)*this.pageSize, this.tilist.length)
                return this.tilist.slice(start, end)
            },
            pageNum(){
                return Math.ceil(this.tilist.length / this.pageSize) || 1 ;
            }
        },
        methods:{
            prePage: function(){
                let vm = this;
                if (vm.currentPage === 0) return;
                vm.currentPage--;
            },
            async nextPage(t,xuanxiang){
                this.zhiRadio=xuanxiang;

                console.log(t, xuanxiang);
                let zx=setTimeout(async()=>{
                    this.controllerTopicShow=false;
                    function MapTOJson(m) {
                        var str = '{';
                        var i = 1;
                        m.forEach(function (item, key, mapObj) {
                            console.log('特殊处理的item');
                            console.log(item);
                            if(mapObj.size == i){
                                str += '"'+ String(key)+'":'+ item + '';
                            }else{
                                str += '"'+ String(key)+'":'+ item+ ',';
                            }
                            i++;
                        });
                        str +='}';
                        return str;
                    }
                    this.allTopicOptions.set(t,xuanxiang);
                    let xx=setTimeout(async ()=>{
                        this.zhiRadio=null;
                        this.currentPage++;
                        this.listenTopic+=1;
                        this.controllerTopicShow=true;
                        clearTimeout(xx);
                        console.log(this.$route.query.name);
                        console.log(this.listenTopic,this.tilist.length);
                        if(this.listenTopic===this.tilist.length){
                            this.loading=true;
                            console.log('来了');
                            console.log(this.listenTopic);
                            if(this.listenTopic<this.tilist.length)return;
                            console.log('最后一题了我进来了');
                            //最后一题提交全部题目
                            console.log(this.record_id, JSON.parse(MapTOJson(this.allTopicOptions)));
                            let result=await commitAllTopic(this.record_id,JSON.parse(MapTOJson(this.allTopicOptions)));
                            if(result.status){
                                this.loading=false;
                                console.log(result);
                                console.log(result.data.result);
                                if(this.$route.query.name==='4'||this.$route.query.name===4){
                                    // this.$router.push({path:'/teacherCenterDashboard/' +
                                    //         'careerplanningDashboard/careerassessmentUp/' +
                                    //         'careertestreport',
                                    //     query:{id:this.$route.query.name,yaLiContent:result.data.data.content,
                                    //         yaLiIcon:result.data.data.icon,yaLiTitle:result.data.data.result}})
                                    this.$router.push({path:'/teacherCenterDashboard/' +
                                            'careerplanningDashboard/careerassessmentUp/' +
                                            'careertestreport',
                                        query:{id:this.$route.query.name,historyId:this.record_id}})

                                }else {
                                    // this.$router.push({path:'/teacherCenterDashboard/' +
                                    //         'careerplanningDashboard/careerassessmentUp/' +
                                    //         'careertestreport',
                                    //     query:{id:this.$route.query.name,rengeLeixResult:JSON.stringify(result.data)}})
                                    this.$router.push({path:'/teacherCenterDashboard/' +
                                            'careerplanningDashboard/careerassessmentUp/' +
                                            'careertestreport',
                                        query:{id:this.$route.query.name,historyId:this.record_id}})
                                }
                            }
                        }
                    },500);
                    clearTimeout(zx);
                },100)
            },
            increase() {
                if(this.$route.query.name==='2'||this.$route.query.name===2){
                    this.percentage +=2.5;
                }else if(this.$route.query.name==='1'||this.$route.query.name===1){
                    this.percentage+=1.66;
                }else if(this.$route.query.name==='6'||this.$route.query.name===6){
                    this.percentage+=1;
                }else if(this.$route.query.name==='3'||this.$route.query.name===3){
                    this.percentage+=1.66;
                }else if(this.$route.query.name==='4'||this.$route.query.name===4){
                    this.percentage+=2.5;
                }else{
                    this.percentage+=1;
                }

                if (this.percentage > 100) {
                    this.percentage=100;
                }
                if(this.percentage===100){
                    this.percentage = 100;
                }
            },
            otherincrease(){
                this.format()
            },
            //进度条循环操作
            format(percentage){
                let zhi=0;
                for(let i=0;i<this.tilist.length;i++){
                    zhi++;
                    if(percentage ===i+1){
                        return percentage===i+1 ? (zhi )+`/${this.tilist.length}`:``;
                    }
                }
            }
        },
        created(){
            //切换测试
            console.log('用户id');

            startceping(this.$route.query.name).then((result)=>{
                this.record_id=result.data.record_id;
                this.tilist=result.data.questions;
                console.log('我是获取到的题目内容');
                console.log(result.data );
            }).catch((error)=>{
                //console.log(error);
            })
        },
    }
</script>

<style scoped>
    .container-head-top{
        width:100%;
        height:100%;
    }
    .personality{
        text-align: left;
        width: 1200px;
        margin: 0 auto;

    }
    /*设置按钮样式*/
    .settingBtnStyle{
        display: inline-block;
        width:100%;
        height:50px;
        line-height: 50px;
        padding-left: 20px;
    }
    .settingBtnStyle:hover{
        background: #fff3e0;
        cursor: pointer;
    }
    .personality .backmenu{
        border-bottom: solid 1px #e2e2e2;
        padding-bottom: 15px;
    }
    .personality .backmenu a,span{
        font-size: 13px;
        color: #666;
    }
    .personality .backmenu a:hover{
        color:#2db7f5;
    }
    .personality .topic{
        background: #ffffff;
        padding: 20px;
        padding-top:40px;
        font-size: 18px;
    }
    .personality .topic .topicTitle{
        display: flex;
        justify-content: space-between;

    }
    .ticontent{
        margin-top: 20px;
    }
    .ticontent-input{
        margin: 20px 10px ;
    }
</style>
